/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_IncreasedInputs */

const he_item_stats_increased = /** @type {(inputs: Item_Stats_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחיר עלה`)
};

const en_item_stats_increased = /** @type {(inputs: Item_Stats_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price increased`)
};

/**
* | output |
* | --- |
* | "Price increased" |
*
* @param {Item_Stats_IncreasedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const item_stats_increased = /** @type {((inputs?: Item_Stats_IncreasedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_IncreasedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_increased(inputs)
	return en_item_stats_increased(inputs)
});